import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { EventType, Router, RouterOutlet } from "@angular/router";
import { ThemeService } from "design-system";
import { SideNavComponent } from "./views/root/components/side-nav/side-nav.component";
import { excludedRoutes } from "./views/root/components/side-nav/sidenav.constants";
import { SnackbarService } from "design-system";
import { WsManagerService } from "./shared/services/api-services/ws-manager.service";
import { PosthogService } from "./shared/services/monitoring/posthog.service";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrl: "./app.component.css",
	imports: [RouterOutlet, SideNavComponent],
})
export class AppComponent implements OnInit {
	includeSideNav = false;
	constructor(
		private router: Router,
		private cd: ChangeDetectorRef,
		private themeingSerivice: ThemeService,
		private posthog: PosthogService,
	) {}
	ngOnInit() {
		this.themeingSerivice.setTheme("light");
		this.router.events.subscribe((event) => {
			if (event.type === EventType.NavigationEnd) {
				this.posthog.capture("$pageview", {
					$current_url: event.urlAfterRedirects,
				});
				excludedRoutes.find((route) => route.includes(event.url))
					? (this.includeSideNav = false)
					: (this.includeSideNav = true);
				this.cd.detectChanges();
			}
		});
	}

	title = "Kea Web";
}
